import React, { useRef, useState } from 'react';

import { calendar } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { Capacitor } from '@capacitor/core';
import { InputAdornment, Menu, SvgIcon } from '@material-ui/core';
import { format, intlFormat } from 'date-fns';
import ReactDatePicker from 'react-datepicker';

import { FormInput } from '../Inputs';
import { Blurb } from '../Inputs/Blurb';
import styles from './DatePicker.module.scss';

const isCapacitor = Capacitor.isNativePlatform();

type DatePickerProps = {
	value?: string;
	className?: string;
	error?: string;
	onChange?: (value: string) => void;
	filterDate?: (date: Date) => boolean;
};

export const DatePicker: React.FC<DatePickerProps> = ({
	className,
	value,
	error,
	onChange,
	filterDate,
}) => {
	const [anchorEl, setAnchorEl] = useState<Element | null>(null);
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={styles['root']}>
			<FormInput
				inputClassName={classNames([
					isCapacitor && styles['center-date-input'],
				])}
				placeholder="Select date"
				name="date"
				id="date"
				value={
					value &&
					intlFormat(new Date(value), {
						month: 'long',
						day: 'numeric',
						year: 'numeric',
					})
				}
				onClick={(e) => {
					setAnchorEl(e.currentTarget);
					setIsOpen(true);
				}}
				// onBlur={handleBlur}
				endAdornment={
					!isCapacitor && (
						<InputAdornment
							position="end"
							className={styles['adornment']}
						>
							<SvgIcon component={calendar} />
						</InputAdornment>
					)
				}
				error={!!error}
			/>
			<Menu
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}
				open={isOpen}
				onClose={() => {
					setIsOpen(false);
				}}
				classes={{
					list: styles['list'],
				}}
			>
				<ReactDatePicker
					selected={value ? new Date(value) : new Date()}
					calendarClassName={styles['react-datepicker-calendar']}
					inline
					filterDate={filterDate}
					onChange={(date) => {
						setIsOpen(false);

						if (date) {
							onChange && onChange(date.toISOString());
						}
					}}
				/>
			</Menu>
			{!!error && <Blurb isError>{error}</Blurb>}
		</div>
	);
};
